import { setTokens } from 'src/core/classes/helpers/StorageHelper'
import { IAppState } from 'src/core/store/state'

interface IEnableSimulation {
  appState: IAppState
  accessToken: string
  refreshToken: string
}

export const enableSimulation = ({ appState, accessToken, refreshToken }: IEnableSimulation) => {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.setItem('realUser', appState.user.email || '')
  sessionStorage.setItem('simulation', '1')

  setTokens(appState.app.ownerId, accessToken, refreshToken)

  window.location.reload()
}
